import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import INewsArticle from "apiConsumers/newsApiConsumer/models/INewsArticle";
import ArticleTitle from "components/news/ArticleTitle";
import ArticleContent from "components/news/ArticleContent";
import { fonts, skeletonAnimation, skeletonColour, featureTileYellow, zigzagBackgroundBlack } from "theme";
import Spacer from "components/Spacer";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import NewsArticleSection from "./NewsArticleSection";
import clsx from "clsx";
import ZigZagPatternBackground from "components/backgrounds/ZigZagPatternBackground";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            // backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
            backgroundColor: zigzagBackgroundBlack,
            fontFamily: fonts.secondary,
            position: "relative",
            "@media (max-width: 500px)": { fontSize: "13px" },
        },
        imageSkeleton: { backgroundColor: skeletonColour },
        articleSection: {
            color: theme.palette.common.white,
            zIndex: 1,
            position: "relative",
        },
        articleTitle: {
            color: featureTileYellow,
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {
    article?: INewsArticle;
    isLoading?: boolean;
}

export default function NewsArticlePageContent(props: IProps) {
    const classes = useStyles();

    const { article = {}, isLoading, className, ...rest } = props;
    const { title, content = [] } = article;

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            <ZigZagPatternBackground />
            <NewsArticleSection className={classes.articleSection}>
                {isLoading ? (
                    <>
                        <Typography variant="h4">
                            <Skeleton
                                className={classes.imageSkeleton}
                                animation={skeletonAnimation}
                                variant="rect"
                                width="100%"
                            />
                        </Typography>
                        <Spacer />
                        <Typography variant="subtitle2">
                            <Skeleton
                                className={classes.imageSkeleton}
                                animation={skeletonAnimation}
                                variant="rect"
                                width="35%"
                            />
                        </Typography>
                        <Spacer size={2} />
                    </>
                ) : typeof props.article === "undefined" ? (
                    <Typography variant="subtitle1">Article not found</Typography>
                ) : (
                    <>
                        <ArticleTitle title={title} className={classes.articleTitle} />
                        <Spacer size={2} />

                        <ArticleContent articleContent={content} />
                    </>
                )}
            </NewsArticleSection>
        </div>
    );
}
